<template>
  <div class="home-body">
    <div class="wrap-black banner-with-copy">
      <div class="row">

        <div class="col-xs-12 col-sm-push-6 col-sm-6">
          <div class="banner-copy">
            <h1>Contact <br />Us</h1>
            <p>
              Please feel free to contact us with any questions or concerns you might have. We're happy to help you out!
              Please use this form provided and we will get back to you shortly. If you'd like to learn more about our services check out our features page.
            </p>
            <router-link :to="{name: 'features'}" class="btn-pub btn-pub-blank fixed-width xs-full-width">Learn More</router-link>
          </div>
        </div>
        <div class="col-xs-12 col-sm-pull-6 col-sm-6 pic">
          <InquiryForm subject="General Inquiry"></InquiryForm>
        </div>
      </div>
    </div>
  </div>
</template>


<script>
  import _ from 'underscore'
  import InquiryForm from '../home/InquiryForm'
  


  export default {
    components: {
      InquiryForm,
    },
  }
</script>


<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
  .home-body { background: #FFFFFF; }
</style>




// WEBPACK FOOTER //
// ContactUsPage.vue?1b784841